export default __webpack_public_path__ + "static/media/09_toyota.fc1d9856.png";